/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type GetEvalSuiteRequest = {
  suiteId: string;
  /**
   * Optional external end-user identifier forwarded by the API gateway.
   */
  xOnBehalfOf?: string | undefined;
};

/** @internal */
export const GetEvalSuiteRequest$inboundSchema: z.ZodType<
  GetEvalSuiteRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  suite_id: z.string(),
  "X-On-Behalf-Of": z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    "suite_id": "suiteId",
    "X-On-Behalf-Of": "xOnBehalfOf",
  });
});
/** @internal */
export type GetEvalSuiteRequest$Outbound = {
  suite_id: string;
  "X-On-Behalf-Of"?: string | undefined;
};

/** @internal */
export const GetEvalSuiteRequest$outboundSchema: z.ZodType<
  GetEvalSuiteRequest$Outbound,
  z.ZodTypeDef,
  GetEvalSuiteRequest
> = z.object({
  suiteId: z.string(),
  xOnBehalfOf: z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    suiteId: "suite_id",
    xOnBehalfOf: "X-On-Behalf-Of",
  });
});

export function getEvalSuiteRequestToJSON(
  getEvalSuiteRequest: GetEvalSuiteRequest,
): string {
  return JSON.stringify(
    GetEvalSuiteRequest$outboundSchema.parse(getEvalSuiteRequest),
  );
}
export function getEvalSuiteRequestFromJSON(
  jsonString: string,
): SafeParseResult<GetEvalSuiteRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => GetEvalSuiteRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'GetEvalSuiteRequest' from JSON`,
  );
}
